export default __webpack_public_path__ + "static/char-s-16-cht-3e5a5c1b255c8866387d285d4565157a.webp";